import { useEffect, useState } from 'react';

export const useGlobalFilters = () => {
	const [globalFilterOptions, setGlobalFilterOptions] = useState([]);
	const [isGlobalFiltersLoading, setIsGlobalFiltersLoading] = useState(false);

	useEffect(() => {
		const getGlobalFilters = async () => {
			setIsGlobalFiltersLoading(true);

			//DatasetRecords - Change this to be a ConvokeDataItem???
			const globalOptions = [{DataKey:"",Records:[],ErrorCodes:[]}]; //string,List<Dic<string,object>>,int[]  // await getGlobalFilterOptions();
			const payload = {
				globalFilterOptions: globalOptions,
				timestamp: Date.now()
			};

			setGlobalFilterOptions(globalOptions);
			sessionStorage.setItem("GlobalFilterOptions", JSON.stringify(payload))
		} 

		const stored = sessionStorage.getItem("GlobalFilterOptions");

        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                const age = Date.now() - parsed.timestamp;
                const oneHour = 60 * 60 * 1000;

                if (age < oneHour) {
                    setGlobalFilterOptions(parsed.globalFilterOptions);
                    return;
                } else {
                    sessionStorage.removeItem("GlobalFilterOptions");
                }
            } catch (e) {
                sessionStorage.removeItem("GlobalFilterOptions");
            }
        }
		getGlobalFilters();
	}, []);

	return {
		globalFilterOptions, isGlobalFiltersLoading
	}
} 